"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthCodeRecord = void 0;
/* eslint-disable require-jsdoc */
const firestore_1 = require("firebase/firestore");
const types_1 = require("../../main/types");
class AuthCodeRecord extends types_1.AuthCodeRecordBase {
    static collection(db, collectionPath) {
        return (0, firestore_1.collection)(db, collectionPath).withConverter(AuthCodeRecord.converter);
    }
}
exports.AuthCodeRecord = AuthCodeRecord;
AuthCodeRecord.converter = {
    toFirestore(data) {
        return {
            uid: data.uid,
            expirationDate: firestore_1.Timestamp.fromDate(data.expirationDate)
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const authCode = snapshot.id;
        const uid = documentData.uid;
        const expirationDate = documentData.expirationDate.toDate();
        const data = new AuthCodeRecord(uid);
        data.authCode = authCode;
        data.expirationDate = expirationDate;
        return data;
    }
};
